import clsx from "clsx"
import { Children } from "~/types"

const PageContent = ({ children }: Children) => {
  return <div className={clsx("h-full px-4 py-8", "md:px-8")}>{children}</div>
}

export default PageContent
